import { StaticContent } from 'interfaces/StaticContent'

export const policy: Array<StaticContent> = [
  {
    title: 'Общие положения',
    content: [
      'Настоящая Политика конфиденциальности и обработки персональных данных (далее «Политика») составлена в соответствии с требованиями закона Республики Казахстан от 21 мая 2013 года № 94-V «О персональных данных и их защите» и определяет порядок сбора и обработки персональных данных Пользователей и Пассажиров, а также соответствующие меры по обеспечению безопасности персональных данных',
      'Настоящая Политика устанавливает порядок и цели сбора и обработки Персональных данных и является неотъемлемой частью Публичной оферты.',
      'Оператор прилагает максимальные технические, юридические и организационные меры для защиты Персональных данных. Однако, принимая во внимание увеличение количества несанкционированного доступа со стороны третьих лиц, Оператор не может гарантировать полной защиты Персональных данных.',
    ],
  },
  {
    title: 'Термины и определения',
    terms: [
      {
        description: 'ТОО «Nur-Kassa»',
        name: 'Оператор',
      },
      {
        description: 'https://bile-bile.kz/',
        name: 'Сайт или Электронный информационный ресурс',
      },
      {
        description: 'данные, перечисленные в разделе «Персональные данные, обрабатываемые Сайтом»',
        name: 'Персональные данные',
      },
      {
        description: 'Пользователь и/или Пассажир',
        name: 'Субъект',
      },
      {
        name: '',
        description:
          'Иные термины, определенные в Публичной оферте, имеют идентичное значение в Политике.',
      },
    ],
  },
  {
    title: 'Цели и порядок сбора и обработки персональных данных',
    content: [
      {
        description:
          'Оператор осуществляет сбор и обработку Персональных данных Субъектов в целях:',
        contentType: 'numbers',
        content: [
          'Оператор осуществляет сбор и обработку Персональных данных Субъектов в целях:',
          'идентификации на Сайте;',
          'предоставления поддержки Службы поддержки в ходе использования Сайта;',
          'информирования посредством отправки электронных писем и смс сообщений, в том числе по вопросам, связанным с использованием Сайта;',
          'предоставления информации о новых продуктах и услугах, специальных предложениях и различных событиях;',
          'направления рекламных материалов;',
          'анализа качества предоставляемых Услуг и улучшения качества обслуживания.',
        ],
      },
      'Сбор Персональных данных и их обработка осуществляется Оператором на основании предоставления Персональных данных Субъектом либо его законным представителем путем добровольного заполнения соответствующих форм на Сайте.',
    ],
  },
  {
    title: 'Персональные данные, обрабатываемые сайтом',
    content: [
      {
        description:
          'Оператор с использованием функционала Сайта осуществляет сбор и обработку следующих Персональных данных:',
        contentType: 'none',
        content: [
          '(1) Фамилия, имя, отчество;',
          '(2) ИИН;',
          '(3) Дата рождения;',
          '(4) Пол;',
          '(5) Данные документа, удостоверяющего личность, включая номер, дату и орган выдачи такого документа;',
          '(6) Электронный адрес;',
          '(7) Номер телефона.',
        ],
      },
      'В случае предоставления Субъектом иных персональных данных Оператору вне функционала Сайта посредством обращения по контактным данным Оператора, Субъект дает согласие на сбор и обработку таких данных наравне с Персональными данными, указанными в настоящем Разделе, в соответствии с настоящей Политикой.',
    ],
  },
  {
    title: 'Хранение и передача персональных данных третьим лицам',
    content: [
      'Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых, организационных и технических мер, необходимых для выполнения требований действующего законодательства в области защиты персональных данных. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц.',
      'Собранные Оператором Персональные данные хранятся на территории Республики Казахстан и не подлежат передаче третьим лицам без письменного согласия Субъекта Персональных данных, за исключением передачи Персональных данных в адрес Перевозчика и иных случаев, установленных законодательством Республики Казахстан.',
      'В случае осуществления трансграничной передачи, до начала осуществления трансграничной передачи персональных данных Оператор обязан убедиться в том, что иностранным государством, на территорию которого предполагается осуществлять передачу персональных данных, обеспечивается надежная защита прав субъектов персональных данных, либо  получить соответствующее согласие субъекта персональных данных на трансграничную передачу его персональных данных.',
    ],
  },
  {
    title: 'Обезличивание и уничтожение персональных данных',
    content: [
      'После достижения целей сбора и обработки Персональных данных такие Персональные данные подлежат уничтожению.',
      'Помимо сбора Персональных данных на сайте производится сбор и обработка обезличенных данных о посетителях (в т.ч. файлов «cookie») с помощью сервисов интернет-статистики.',
      'Обезличенные данные Субъектов, собираемые с помощью сервисов интернет-статистики, служат для сбора информации о действиях Субъектов на сайте, улучшения качества сайта и его содержания.',
      'Субъект может в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору уведомление посредством электронной почты на электронный адрес Оператора admin@bile-bile.kz с пометкой «Отзыв согласия». В случае отзыва согласия, данные, предоставленные Оператору, подлежат уничтожению в течение 5 (пяти) рабочих дней с момента получения информации об отзыве согласия.',
    ],
  },
  {
    title: 'Заключительные положения и согласие пользователя',
    content: [
      'Субъект признает и соглашается, что регистрация Субъекта на Сайте, создание учетной записи и последующее использование Сайта и любого его функционала означает безоговорочное согласие Пользователя со всеми пунктами настоящей Политики, безоговорочное принятие ее условий и предоставление Оператору согласия на сбор и обработку Персональных данных.',
      'Оператор оставляет за собой право по своему личному усмотрению изменять и (или) дополнять Политику в любое время без предварительного и (или) последующего уведомления Пользователя. Новая редакция Политики вступает в силу с момента ее размещения на Сайте.',
      'Продолжение Субъектом использования Сайта после любых изменений Политики означает его согласие с такими изменениями и/или дополнениями. Субъект обязуется регулярно знакомиться с содержанием настоящей Политики в целях своевременного ознакомления с ее изменениями.',
      'Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору.',
    ],
  },
]
